import { MetricUId } from "../../Metrics/constants"
import i18n from "../../../../utils/ChrI18n";
import getChartConfigTemplate from "../Templates/PieChart/utils";
import { mergeProps } from "../../../generic/Utils/mergeProps";

const metricColorMap = {
  [MetricUId.PENDING_MEMBERSHIP_APPLICATIONS]: "#FC8543",
  [MetricUId.ACCEPTED_MEMBERSHIP_APPLICATIONS]: "#0969DA",
  [MetricUId.REJECTED_MEMBERSHIP_APPLICATIONS]: "#FA5F5F"
}

const getChartConfig = function(props = {}) {
  const mergedProps = mergeProps(props, {
    seriesMetricsUids: [MetricUId.PENDING_MEMBERSHIP_APPLICATIONS, MetricUId.ACCEPTED_MEMBERSHIP_APPLICATIONS, MetricUId.REJECTED_MEMBERSHIP_APPLICATIONS],
    subTitleMetricUid: MetricUId.RECEIVED_MEMBERSHIP_APPLICATIONS,
    exportFileName: i18n.t("widgets.membership_applications.title"),
    metricColorMap: metricColorMap
  });

  return getChartConfigTemplate(mergedProps);
};

export default getChartConfig;
